module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-800.b7018be9.woff2";